import React, { Component } from 'react'
import {Switch ,Route}from 'react-router-dom';

import landingPage from './landingPage';
import About from './aboutMe';
import Contact from './contact';
import Projects from './projects';
import Resume from './resume';

const Main =()=>(
    <Switch>
    <Route exact path="/" component={landingPage}/>
    <Route path="/aboutMe" component={About}/>
    <Route path="/resume" component={Resume}/>
    <Route path="/projects" component={Projects}/>
    <Route path="/contact" component={Contact}/>

    </Switch>

)

export default Main;